// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.travel-costs__tooltip .sk-tooltip__btn {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.travel-cost-apply__travel-costs .travel-costs__currency {\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
